import React, { FC } from 'react';
import { LoadingButton } from 'components/loadingbutton/LoadingButton';
import { useTranslation } from 'react-i18next';
import styles from '../default/styles.module.scss';

interface PaymentButtonProps {
  showChecklist?: boolean;
  isLoading: boolean;
  label?: string | React.ReactNode;
}

export const ApplePayElement: FC<
  PaymentButtonProps & { onPay: () => void }
> = ({ isLoading, label, showChecklist = true, onPay }) => {
  const { t } = useTranslation();

  return (
    <div>
      {showChecklist && (
        <ul className={styles.checkList}>
          <li>Fast payment using Touch or Face ID</li>
          <li>Protects your personal data</li>
          <li>Purchases stay private</li>
        </ul>
      )}

      <LoadingButton
        isLoading={isLoading}
        label={label ? label : t('pay')}
        onClick={onPay}
        className={`${styles.applePayBtn} ${label ? styles.withoutIcon : ''}`}
      />
    </div>
  );
};
